export const CURRENT_TASK_PLACEHOLDER = "__CURRENT_TASK__";

export const createCycleRow = (overrides = {}) => {
  const normalizedTaskId =
    overrides.taskId !== undefined && overrides.taskId !== null
      ? String(overrides.taskId)
      : null;

  return {
    id: overrides.id ?? null,
    clientId: overrides.clientId ?? `cycle-${Math.random().toString(36).slice(2, 10)}`,
    taskId: normalizedTaskId,
    interval:
      overrides.interval !== undefined && overrides.interval !== null
        ? String(overrides.interval)
        : "",
    meterId:
      overrides.meterId !== undefined && overrides.meterId !== null
        ? Number(overrides.meterId)
        : null,
  };
};

export const resolveAssetMeterId = (task) => {
  if (!task) return null;
  const rawValue =
    typeof task.assetMeterId === "object" && task.assetMeterId !== null
      ? task.assetMeterId.id
      : task.assetMeterId ?? task.assetMeter?.id ?? task.assetMeter?.assetMeterId;
  const numeric = Number(rawValue);
  return Number.isFinite(numeric) ? numeric : null;
};
